import { jsx as r } from "@emotion/react/jsx-runtime";
import { memo as e, useMemo as n } from "react";
import { Stack as i } from "../../Stack/index.js";
import { BusinessCard as t } from "../BusinessCard/BusinessCard.js";
const a = 6, p = ({
  row: s = a
}) => {
  const o = n(() => Array(s).fill(null), [s]);
  return /* @__PURE__ */ r(i, { gap: "8px", children: o.map((u, m) => /* @__PURE__ */ r(t, {}, m)) });
}, l = e(p);
export {
  l as BusinessCards
};
